var map = {
	"./2 Bridge logo.jpg": "a354",
	"./4X Travel-Uniglobe.jpg": "7ef9",
	"./APEC.jpg": "11cc",
	"./Adient.jpg": "ee21",
	"./Atlas Copco.jpg": "c3a9",
	"./Aurubis.jpg": "2d58",
	"./Autajon.jpg": "6cb4",
	"./Avery Dennison.jpg": "1d5c",
	"./BECTON DICKINSON.jpg": "0f00",
	"./BEKAERT.jpg": "590e",
	"./BLUE B.jpg": "6b9d",
	"./BLUE.jpg": "a891",
	"./Borealis.jpg": "5a85",
	"./Campine.jpg": "0ccb",
	"./Carta Mundi.jpg": "2b29",
	"./DSV.jpg": "8ee5",
	"./Ecover.jpg": "86f3",
	"./Estee Lauder.jpg": "26cd",
	"./GROZ BECKERT.jpg": "6c7f",
	"./Glaxosmith.jpg": "63a5",
	"./Griffith.jpg": "16f0",
	"./Groundscope.jpg": "0fc4",
	"./HONDA.jpg": "6ad2",
	"./Hanssen.jpg": "3c0e",
	"./Henkel.jpg": "b34a",
	"./Hino.jpg": "4c3b",
	"./Janssen Pharmaceutica.jpg": "fd68",
	"./Johnson&Johnson.jpg": "c4fe",
	"./Johnson_Johnson.jpg": "6931",
	"./Junker.jpg": "058f",
	"./KGH.jpg": "6407",
	"./Kelloggs.jpg": "ae8a",
	"./Logo Exxon Mobile.jpg": "9840",
	"./Lubrizol.jpg": "79c9",
	"./MHI Vestas.jpg": "7355",
	"./Mondelez.jpg": "3e58",
	"./NHV.jpg": "9392",
	"./Nippon Gases  logo.jpg": "f8d7",
	"./PEGASE.jpg": "eb35",
	"./PLAN BEKAERT.jpg": "aa72",
	"./PLAN VOLVO TRUCKS.jpg": "3125",
	"./PSA.jpg": "32f0",
	"./Philips.jpg": "ef0b",
	"./Plastic Omnium.jpg": "66c3",
	"./Praxair.jpg": "eb2d",
	"./SOLERAS.jpg": "c09d",
	"./Saint Gobain.jpg": "1e12",
	"./Sanofi.jpg": "67b9",
	"./Smurfit Kappa.jpg": "a230",
	"./Soudal.jpg": "6158",
	"./Sumitomo.jpg": "6bf6",
	"./Sumitomo_Hansen.jpg": "9966",
	"./TUIfly.jpg": "4872",
	"./Umicore.jpg": "955b",
	"./VIP SELECTION.jpg": "d466",
	"./VITO.jpg": "9338",
	"./VLERICK.jpg": "099d",
	"./VOLVO CARS.jpg": "8d45",
	"./VOLVO TRUCKS.jpg": "9f9c",
	"./Wienerberger.jpg": "03c8",
	"./Wilms.jpg": "59b9",
	"./ZF WIND POWER LOGO.jpg": "8b90",
	"./piramal.jpg": "6830"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c53f";